import React from 'react';
import { KardexReportComponent } from '@/pages/reports/components/KardexReport';

export const KardexPage: React.FC = () => {
  return (
    <div className="p-3 md:p-6 space-y-4 md:space-y-6 h-full overflow-auto">
      <KardexReportComponent />
    </div>
  );
};